import { $api } from "../../../../services/request.config";
import { getMaterinityDisDocsAction } from "../getMaterinityDisDocs.action";

export const getMaterinityDisDocsThunkAction = () => async (dispatch) => {
    try {
        const response = await $api("v1/request/leave/maternity/dis-docs");
        if (response) {
            // const temp =
            dispatch(getMaterinityDisDocsAction(response.data));
        }
    } catch (error) {
        throw error instanceof Error ? error : new Error(JSON.stringify(error?.response?.data ?? error));
    }
};
